// How each skill reads in a sentence ("I bring marketing", "Needs a
// developer"). itemIds match data/skills.json and the backend's Skill rows;
// `key` is what /welcome?bring=&need= takes (components/onboarding/config.js).
export const SKILL_PHRASES = [
  { itemId: 1, key: "dev", label: "Developer", bring: "development", need: "a developer", help: "Development" },
  { itemId: 4, key: "biz", label: "Business development", bring: "business development", need: "business development", help: "Business development" },
  { itemId: 6, key: "product", label: "Product", bring: "product", need: "a product lead", help: "Product" },
  { itemId: 3, key: "mkt", label: "Marketer", bring: "marketing", need: "a marketer", help: "Marketing" },
  { itemId: 5, key: "sales", label: "Sales", bring: "sales", need: "a salesperson", help: "Sales" },
  { itemId: 2, key: "design", label: "Designer", bring: "design", need: "a designer", help: "Design" },
]

export const skillById = (itemId) =>
  SKILL_PHRASES.find((s) => s.itemId === Number(itemId)) || null

export const skillByKey = (key) => SKILL_PHRASES.find((s) => s.key === key) || null

// "a developer", "a developer and a designer", "a developer, sales and a designer"
export const joinAnd = (parts) =>
  parts.length <= 1
    ? parts.join("")
    : `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}`

// "Needs a developer and business development", from a founder's wantsSkills
// in SKILL_PHRASES order; past `max` it ends "and more". Null when they want nobody.
export const needsLine = (wantsSkills, max = 2) => {
  const ids = (wantsSkills || []).map((s) => Number(s.itemId))
  const phrases = SKILL_PHRASES.filter((s) => ids.includes(s.itemId)).map((s) => s.need)
  if (phrases.length === 0) return null
  if (phrases.length > max) return `Needs ${phrases.slice(0, max).join(", ")} and more`
  return `Needs ${joinAnd(phrases)}`
}
